angular.module('zc')
  .component('zcSiteReportKpiSummary', {
    templateUrl: '/templates/projects.site_reports/kpi_summary.html',
    bindings: { project: '<' },
    controller: zcSiteReportKpiSummaryController,
  });

zcSiteReportKpiSummaryController.$inject = ['$scope'];
function zcSiteReportKpiSummaryController($scope, currencies) {
  const vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    this.simulation = calculateSimulation();
  });

  function calculateSimulation() {
    const today = moment().add(1, 'day').startOf('day');
    const monthFrom = moment(vm.project.thisMonthStat.start_at).startOf('month');
    const monthTo = moment(vm.project.thisMonthStat.start_at).add(1, 'month').startOf('month');
    const monthDays = monthTo.diff(monthFrom, 'days');
    const currentFrom = moment(vm.project.thisMonthStat.start_at).startOf('day');
    const currentTo = moment.min(monthTo, today);
    const currentDays = currentTo.diff(currentFrom, 'days');
    if(currentDays <= 0) return null;
    return monthDays / currentDays;
  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.site_reports/kpi_summary.controller.js